import {
  ApiDataSourceSpec,
  apiDataSource,
} from '@/io/datasource/ApiDatasource';
import {
  MailPreference,
  MailPreferenceUpdate,
  mailPreferenceSchema,
} from '@/models/MailPreferenceModel';
import { cz } from '@/utils/zodUtils.ts';

export class MailPreferenceRepository {
  constructor(private readonly datasource: ApiDataSourceSpec = apiDataSource) {}

  getPreferences = (): Promise<MailPreference[]> => {
    return this.datasource.get(
      'practitioner/mail-preferences/',
      cz.forcedArray(mailPreferenceSchema),
    );
  };

  updatePreferences = (data: MailPreferenceUpdate): Promise<unknown> => {
    return this.datasource.post(
      'practitioner/mail-preferences/',
      cz.ignore(),
      data,
    );
  };
}
